import { getStops } from "../../../app/api/getStops";
import { BaseAction } from "../../../core/actions/BaseAction";
import { getRuntimeConfig } from "../../../Lib/Config/RuntimeConfig";
import { getMappedStopCode } from "../../../Lib/Utils/StopManager";
import { getRecoilStateValue, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse, IStop } from "../../../Orchestrator/Types/Index";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { ISelectedCategoryAndSubCategory, IServiceRequestCategory, IServiceRequestCustom } from "../../../Orchestrator/Types/Interface/IServiceRequest";

class SetAdditionalFieldsAction extends BaseAction<IDefaultActionResult, void> {

    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: false,
            message: "",
            status: "fail"
        }
        try {

            const serviceCategories: IServiceRequestCustom[] = getRecoilStateValue("serviceCategoriesAtom") || [];
            const selectedCategoryAndSubCategory: ISelectedCategoryAndSubCategory | undefined = getRecoilStateValue("selectedCategoryAndSubCategoryAtom");
            if (serviceCategories && selectedCategoryAndSubCategory) {
                let additionalFields =
                    (
                        serviceCategories.find(
                            (service) =>
                                service.categoryName === selectedCategoryAndSubCategory.category
                        )?.subCategories || []
                    )?.find(
                        (subCat: IServiceRequestCategory) =>
                            subCat.name === selectedCategoryAndSubCategory.subCategory
                    )?.additionalFields || [];

                const isStationField = additionalFields.find(d => d.type === "STATION")
                if (isStationField) {
                    const config = await getRuntimeConfig();
                    const stopExternalCode = config.NEXT_PUBLIC_STOP_EXTERNAL_CODE;
                    const response: IApiResponse<{ stops: IStop[] }> = await getStops();
                    if (response.status === "ok" && response.answer) {
                        const stops = response.answer.stops;
                        if (stops.length > 0) {
                            const mappedStopValues = stopExternalCode
                                ? stops
                                    .map((stop) => getMappedStopCode(stop, stopExternalCode))
                                    .filter((value): value is string => Boolean(value))
                                : [];
                            additionalFields = additionalFields.map(({ ...d }) => {
                                if (d.type === "STATION") {
                                    d.values = mappedStopValues
                                }
                                return d
                            })
                        }
                    }
                }
                const isOnlyHelpInfoField = additionalFields.find(d => d.type === "HELP_INFO")
                if (isOnlyHelpInfoField && additionalFields.length === 1) {
                    updateRecoilState("submitRequestButtonDisabledAtom", false)
                } else {
                    // Check if all fields are optional - not required
                    const allFieldsOptional = additionalFields?.every(field => !field?.required)
                    if (allFieldsOptional) {
                        updateRecoilState("submitRequestButtonDisabledAtom", false)
                    } else {
                        updateRecoilState("submitRequestButtonDisabledAtom", true)
                    }
                }
                updateRecoilState("additionalFieldsAtom", additionalFields)
                actionResult.status = "success"
            }
        } catch (error) {
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const setAdditionalFieldsAction = new SetAdditionalFieldsAction()
